module.exports = __webpack_public_path__ + "img/evaluate-level2.ea79c33e.png";